import React from "react";
import Footer from "../Shared/Footer";
import Products from "./Products";

const Store = () => {
  return (
    <>
      <main>
        <section className="my-10">
          <h1 className="text-center text-primary font-bold text-2xl">
            All Products
          </h1>
          <Products></Products>
        </section>
      </main>
      <Footer></Footer>
    </>
  );
};

export default Store;
